import type { StoreRole } from '@/types/user';

export const SUPPORT_WHATSAPP_URL = 'https://wa.me/5511918520877';

const SUPPORT_MESSAGE_BASE = 'Olá! Preciso de ajuda com o Minha Menlo.';

// Monta o texto pré-preenchido do link de suporte com a loja do franqueado logado,
// para o operador amarrar o contato ao vínculo certo. Sem loja conhecida, cai no texto base.
export function buildSupportMessage(stores?: StoreRole[]): string {
  const storeNames = (stores ?? []).map((store) => store.tradeName.trim()).filter(Boolean);
  if (storeNames.length === 0) {
    return SUPPORT_MESSAGE_BASE;
  }
  const label = storeNames.length === 1 ? 'Loja' : 'Lojas';
  return `${SUPPORT_MESSAGE_BASE} ${label}: ${storeNames.join('; ')}.`;
}

// Compõe o link wa.me com o contexto via URLSearchParams, nunca por concatenação crua,
// para acento, `/` e `&` no nome da loja chegarem íntegros no WhatsApp.
export function buildSupportWhatsappUrl(stores?: StoreRole[]): string {
  const url = new URL(SUPPORT_WHATSAPP_URL);
  url.searchParams.set('text', buildSupportMessage(stores));
  return url.toString();
}

// Com usuário autenticado, o storeRoles do useUserInfo ainda pode estar carregando no
// primeiro render; esconder o botão de WhatsApp até resolver evita perder o contexto de
// loja no primeiro clique. Deslogado não passa por aqui: a query fica desabilitada e cai
// direto no texto base, então não há "carregando" a esperar.
export function shouldHideWhatsappButton(hasUser: boolean, isLoading: boolean): boolean {
  return hasUser && isLoading;
}
